export default __webpack_public_path__ + "media/images/brighteon-social/Icon-NewPost-Gray-4dd8f48d386f49d2937aefe2e186a7cc.svg";